export default ()=>({
    init(){

    }
})
